document.addEventListener('DOMContentLoaded', function () {
  console.log("this is work");

  const target = document.querySelector('product-recommendations');
  if (!target) return;

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        const relacard = target.querySelector('.rela_prod_slider_main');
        if (relacard) {
          console.log("relacard=======>", relacard);
          initRelatedProducts(relacard);
          observer.disconnect(); // stop observing after init
        }
      }
    });
  });

  observer.observe(target, { childList: true, subtree: true });
});

function initRelatedProducts(relacard) {
  const swiperEl = relacard.querySelector('.rela_prod_slider_swiper');
  console.log("swiperEl=======>", swiperEl);
  if (!swiperEl) return;

  const prevBtn = relacard.querySelector('.rela_prod_slider_swiper_button_prev');
  const nextBtn = relacard.querySelector('.rela_prod_slider_swiper_button_next');
  console.log("prevBtn=======>", prevBtn);
  console.log("nextBtn=======>", nextBtn);

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 'auto',
    spaceBetween: 8,
    loop: false,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    on: {
      init: function () {
        checkScrollable(this, relacard);
      },
      resize: function () {
        checkScrollable(this, relacard);
      },
    },
  });
}

function checkScrollable(swiperInstance, relacard) {
  const mainwrapp = relacard.querySelector('.rela_prod_slider_content');
  const wrapper = swiperInstance.wrapperEl;
  const container = swiperInstance.el;

  console.log("mainwrapp===========>", mainwrapp);
  console.log("container===========>", container);

  if (wrapper.scrollWidth > container.clientWidth) {
    mainwrapp.classList.add("rela_prod_slider_scrollable");
    mainwrapp.classList.remove("rela_prod_slider_not_scrollable");
  } else {
    mainwrapp.classList.remove("rela_prod_slider_scrollable");
    mainwrapp.classList.add("rela_prod_slider_not_scrollable");
  }
}






// document.addEventListener('DOMContentLoaded', function() {
//   console.log("this is work");
//   document.querySelectorAll('product-recommendations .rela_prod_slider_main').forEach(function(relacard) {
//     console.log("relacard=======>",relacard);
//     const swiperEl = relacard.querySelector('.rela_prod_slider_swiper');
//     console.log("swiperEl=======>",swiperEl);
//     if (!swiperEl) return;
//     const prevBtn = relacard.querySelector('.rela_prod_slider_swiper_button_prev');
//     const nextBtn = relacard.querySelector('.rela_prod_slider_swiper_button_next');
//     console.log("prevBtn=======>",prevBtn);
//     console.log("prevBtn=======>",prevBtn);

//     const swiper = new Swiper(swiperEl, {
//       slidesPerView: 'auto',
//       spaceBetween: 8,
//       loop: false,
//       navigation: {
//         nextEl: nextBtn,
//         prevEl: prevBtn,
//       },
//       on: {
//         init: function () {
//             checkScrollable(this);
//         },
//         resize: function () {
//             checkScrollable(this);
//         },
//      },
//     });

//     function checkScrollable(swiperInstance) {
//         const mainwrapp = relacard.querySelector('.rela_prod_slider_content');
//         const wrapper = swiperInstance.wrapperEl;
//         const container = swiperInstance.el;

//         console.log("mainwrapp===========>",mainwrapp);
//         console.log("container===========>",container);

//         if (wrapper.scrollWidth > container.clientWidth) {
//             mainwrapp.classList.add("rela_prod_slider_scrollable");
//             mainwrapp.classList.remove("rela_prod_slider_not_scrollable");
//         } else {
//             mainwrapp.classList.remove("rela_prod_slider_scrollable");
//             mainwrapp.classList.add("rela_prod_slider_not_scrollable");
//         }
//     }

//   });
// });